import { useParams } from 'react-router-dom';

import { PAYROLL_MODEL_IDS } from '@xemplo/gp-types';
import { DawnSettings, IconGradient } from '@xemplo/icons';
import { useGetPayscheduleByIdQuery } from '@xemplo/pay-schedule-query';

import { getFieldsArray } from './outsource-settings-card.helpers';
import * as S from './outsource-settings-card.styles';

export function OutsourceSettingsCard(props: { className?: string }) {
  const { payscheduleId } = useParams<{ payscheduleId: string }>();
  const { data: payScheduleData } = useGetPayscheduleByIdQuery({ id: payscheduleId });

  if (
    !payScheduleData?.result ||
    payScheduleData.result.payrollModelId !== PAYROLL_MODEL_IDS.OUTSOURCE
  ) {
    return null;
  }

  const fields = getFieldsArray(payScheduleData.result);

  return (
    <S.CardContainer className={props.className}>
      <S.Header>
        <S.IconWrapper>
          <DawnSettings fontSize={24} />
          <IconGradient />
        </S.IconWrapper>
        <S.Title>Outsource Settings</S.Title>
      </S.Header>

      <S.FieldsGrid>
        {fields.map((field) => (
          <S.Field key={field.id} data-field-id={field.id}>
            <S.Label>{field.label}</S.Label>
            <S.Value>{field.value}</S.Value>
          </S.Field>
        ))}
      </S.FieldsGrid>
    </S.CardContainer>
  );
}
